import {needAuth} from "../instance/Instance";
import {getApprovalPresets, getApprovalPresetById, saveApprovalPreset} from "./ApprovalV2Service";

export async function getApproverPresets() {
    const response = await getApprovalPresets();
    if (response?.status === 200) {
        return response.data ?? [];
    }
    throw response;
}

export async function getApproverPresetById(presetId) {
    const response = await getApprovalPresetById(presetId);
    if (response?.status === 200) {
        return response.data;
    }
    throw response;
}

export async function saveApproverPreset(data) {
    const response = await saveApprovalPreset(data);
    if (response?.status === 200 || response?.status === 201) {
        return response.data;
    }
    throw response;
}

export async function deleteApproverPreset(id) {
    await needAuth.delete(`/preset/${id}`);
}
